export const siteUrl = 'https://www.hashanj.com';
export const siteTitle = 'Hashan Jayalath - Technical Lead | AI/LLM Expert';
